<template>
  <p v-if="product.summary" qaid="product-summary" class="py-2 border-t border-b border-gray-10 text-xs">
    {{ product.summary }}
  </p>
</template>
<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
};
</script>
